export default __webpack_public_path__ + "fonts/76419cbd5aa1d288fb3a607b33b54274.woff2";